'use strict';

const dataLayerFonctions = require('../rxB2C/rxB2CDataLayer');

/**
 * Init/handle prescription filter element
 */
function handlePrescriptionFilter($this) {
    var isFilterPrescriptionActive = $('.toggle-switch', $this).prop('checked');
    let $spans = $this.find('.toggle-text');
    $spans.toggleClass('active');
    $('.js-hide-on-prescription').addClass('mb-2'); // to align with the prescription estimated min price
    $spans.each(function () {
        $this.attr('aria-pressed', $this.hasClass('active'));
    });

    var $indicator = $this.parent().find('.background-indicator');
    if (isFilterPrescriptionActive) {
        $indicator.css('left', '47%');
    } else {
        $indicator.css('left', '0');
    }

    $('.color-attribute').each(function () {
        var isRx = $(this).attr('data-has-rx-frame') === 'true';
        if (isFilterPrescriptionActive) {
            if (isRx) {
                $(this).removeClass('d-none');
            } else {
                $(this).addClass('d-none');
            }
        } else {
            $(this).removeClass('d-none');
        }
    });

    if (isFilterPrescriptionActive) {
        var $currentSwatchSelection = $('#color-variations-wrapper').find('.swatch.selected');
        $currentSwatchSelection.attr('data-non-prescription-selected', true);

        var firstPrescriptionSwatch = $('#color-variations-wrapper').find('.swatch:visible').first();
        if (firstPrescriptionSwatch.length > 0) {
            if (firstPrescriptionSwatch.hasClass('selected')) {
                switchPrescriptionCTAs(isFilterPrescriptionActive);
            }
            firstPrescriptionSwatch.trigger('click');
        }
    } else {
        var nonPrescriptionPreviouslySelected = $('#color-variations-wrapper').find('.swatch[data-non-prescription-selected="true"]');
        if (!nonPrescriptionPreviouslySelected.length) {
            let $defaultSelectedVariant = $('#color-variations-wrapper').find('.swatch.selected:visible');
            if ($defaultSelectedVariant.length) {
                nonPrescriptionPreviouslySelected = $defaultSelectedVariant;
            } else {
                nonPrescriptionPreviouslySelected = $('#color-variations-wrapper').find('.swatch.selected:visible').first();
            }
        }
        nonPrescriptionPreviouslySelected.attr('data-non-prescription-selected', false);
        if (nonPrescriptionPreviouslySelected.hasClass('selected')) {
            switchPrescriptionCTAs(isFilterPrescriptionActive);
        }
        nonPrescriptionPreviouslySelected.trigger('click');
    }
}

/**
 * switch prescription ctas
 * @param {boolean} isFilterPrescriptionActive - true / false
 */
function switchPrescriptionCTAs(isFilterPrescriptionActive) {
    var soldWithQuoteRequest = $('.pdp-quote-button').data('sold-with-quote-request') === true
        || $('.pdp-quote-button').attr('data-sold-with-quote-request') === 'true';
    if (isFilterPrescriptionActive) {
        $('.rx-url[data-has-rx-url="true"], .prices-add-to-cart-actions').addClass('d-none');
        $('.rx-add-to-cart').removeClass('d-none');
        $('.pdp-quote-button')
            .toggleClass('d-none', soldWithQuoteRequest)
            .toggleClass('d-flex', !soldWithQuoteRequest);
        $('.js-pdp-reinsurance-asset').addClass('d-none');
        $('.js-pdp-reinsurance-asset-rxb2c').removeClass('d-none');
        $('.js-hide-on-rx').addClass('d-none');
        $('.js-show-on-prescription').removeClass('d-none');
        $('.js-hide-on-prescription').addClass('d-none');
    } else {
        $('.rx-url[data-has-rx-url="true"], .prices-add-to-cart-actions').removeClass('d-none');
        $('.rx-add-to-cart').addClass('d-none');
        $('.pdp-quote-button')
            .toggleClass('d-none', !soldWithQuoteRequest)
            .toggleClass('d-flex', soldWithQuoteRequest);
        $('.js-pdp-reinsurance-asset').removeClass('d-none');
        $('.js-pdp-reinsurance-asset-rxb2c').addClass('d-none');
        $('.js-hide-on-rx').removeClass('d-none');
        $('.js-show-on-prescription').addClass('d-none')
        $('.js-hide-on-prescription').removeClass('d-none');
    }
    $('body').trigger('product:afterPrescriptionCTAsUpdated');
}

/**
 * Toggle prescription switch visibility based on available RX variants
 */
function updatePrescriptionFilterVisibility() {
    var hasRxSwatches = $('#color-variations-wrapper .color-attribute').filter(function () {
        return $(this).attr('data-has-rx-frame') === 'true' && !$(this).hasClass('d-none');
    }).length > 0;
    var $filter = $('.rx-prescription-filter');

    if (!$filter.length) {
        return false;
    }

    $filter.toggleClass('d-none', !hasRxSwatches);
    if (!hasRxSwatches) {
        $('.toggle-switch', $filter).prop('checked', false);
        switchPrescriptionCTAs(false);
    }

    return hasRxSwatches;
}

module.exports = function () {
    $('.rx-prescription-filter').each(function () {
        updatePrescriptionFilterVisibility();
        handlePrescriptionFilter($(this));
    });
    $('.rx-prescription-filter').on('click', function (e) {
        var $target = $(e.target);
        if ($target.hasClass('toggle-text')) {
            return;
        }
        e.stopPropagation();

        /** START: data layer */
        dataLayerFonctions.pushPDPFilterPrescription($('.toggle-switch', $(this)).prop('checked'));
        /** END: data layer */

        handlePrescriptionFilter($(this));
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        var isFilterPrescriptionActive = $('.rx-prescription-filter .toggle-switch').prop('checked');
        response.container.find('.pdp-quote-button')
            .attr('data-sold-with-quote-request', response.data.product.productSoldWithQuoteRequest);
        response.container.find('.js-rxb2c-url-link').attr('href', response.data.product.Rxb2cUrl || '');
        if (!updatePrescriptionFilterVisibility()) {
            return;
        }
        switchPrescriptionCTAs(response.data.product.RXFrame && isFilterPrescriptionActive);
        setTimeout(() => {
            $('.js-rx-estimated-min-price').text(response.data.product.RXEstimatedMinPrice.sales.formatted);
        }, 10);
    });

    $('.js-rxb2c-url-link').on('click', function () {
        /** START: data layer */
        dataLayerFonctions.pushPDPClickRXB2C();
        /** END: data layer */
    });
};
